import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import moment from 'moment';
import { useSelector } from 'react-redux';

import * as translations from '../../i18n/locales';
import { selectLanguage, selectClientTranslationURL } from '../../global-selectors';

const withTranslationProvider = (WrappedComponent) => {
  return (props) => {
    const [translation, setTranslation] = useState([]);
    const { language, translationURL } = useSelector((state) => ({
      language: selectLanguage(state),
      translationURL: selectClientTranslationURL(state)
    }));

    const fetchTranslations = () => fetch(translationURL)
      .then(response => response.json())
      .then(data => {
        setTranslation(data);
      });

    useEffect(() => {
      fetchTranslations();
    }, []);

    moment.locale(language);

    const allTranslations = {
      ...translations[language],
      ...translation
    };

    return (
      <IntlProvider
        messages={allTranslations}
        locale={language}
        defaultLocale="es"
      >
        <WrappedComponent {...props} />
      </IntlProvider>
    );
  };
};

export default withTranslationProvider;
